export default "__VITE_ASSET__5khhzczM__"